<template>
  <v-dialog v-model="dialog" max-width="30%">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon small>
        <v-icon small>edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Edit Ship By Date
        <v-spacer />
        <v-btn icon @click="close"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-date-picker v-model="dateValue" />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close"><v-icon left>close</v-icon>Close</v-btn>
        <v-btn text @click="submit" color="green">
          <v-icon left>save</v-icon>Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Project from "../../models/Project";
export default {
  name: "ProjectShippingDateEdit",
  props: {
    current_date: {
      type: String,
      required: true,
      default: new Date().toISOString().substr(0, 10)
    },
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      dateValue: new Date().toISOString().substr(0, 10)
    }
  },
  methods: {
    submit() {
      Project
        .$put(this.id,{ due_on: this.dateValue })
        .then(() => this.close())
    },
    close() {
      this.dialog = false;
    }
  }
}
</script>
